export const SUBSCRIPTION_TIERS_QUERY_KEY = ["admin", "subscription-tiers", "list"] as const;

/**
 * The product picker reads the existing catalog products endpoint. Its own key
 * so it caches independently of the catalog feature's list (no cross-feature
 * import; both just hit `GET /api/admin/catalog/products`).
 */
export const TIER_CATALOG_PRODUCTS_QUERY_KEY = [
  "admin",
  "subscription-tiers",
  "catalog-products",
] as const;

/** `key` must be a stable uppercase slug (the FK target on `subscriptions.tier`). */
export const TIER_KEY_PATTERN = /^[A-Z0-9_]+$/;
export const TIER_KEY_MAX_LENGTH = 64;
export const TIER_DISPLAY_NAME_MAX_LENGTH = 120;

// Bounds mirror the API DTO validators (API-CAP-2). Weight is spaced (100/200…)
// by convention but only required to be a positive unique integer.
export const MIN_TIER_WEIGHT = 1;
export const MAX_TIER_WEIGHT = 1_000_000;
export const MIN_TIER_DAILY_PASS_CAP = 1;
export const MAX_TIER_DAILY_PASS_CAP = 100;
